import { httpService } from '../..';
import { IEntityWithMessages } from '../../services/HttpService';
import { IApiExecuteRespone, IPagedSegmentResponse } from '../apiInterfaces';
import { ApiUrls } from '../ApiUrls';
import { ISalesProspectsFilters } from '../filters';
import { ChangeProspectDirection, IProspect, IProspectApiResponse } from './prospectsInterfaces';

export async function ChangeLifecycleStep(
  prospectId: number,
  direction: ChangeProspectDirection
): Promise<IEntityWithMessages<IProspect>> {
  try {
    const response = await httpService.post(ApiUrls.changeProspectStep(prospectId, direction));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function FetchProspect(request: {
  prospectId?: number;
  businessEntityId?: number;
}): Promise<IProspectApiResponse> {
  try {
    let response: Response | undefined;
    const { businessEntityId, prospectId } = request;

    if (prospectId) {
      response = await httpService.get(ApiUrls.prospectByProspectId(prospectId));
    } else if (businessEntityId) {
      response = await httpService.get(ApiUrls.prospectByBusinessEntityId(businessEntityId));
    }

    if (response) {
      return await response.json();
    }
    throw new Error('A business entity id or prospect id is required');
  } catch (e) {
    throw e;
  }
}

export async function FetchProspects(
  salesDistricts: string[],
  filter: ISalesProspectsFilters,
  skip: number = 0
): Promise<IPagedSegmentResponse<IProspectApiResponse[]>> {
  try {
    const response = await httpService.get(ApiUrls.getProspects(salesDistricts, filter, skip));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function UpdateProspect(
  prospect: IProspect
): Promise<IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.put(ApiUrls.prospectByProspectId(prospect.prospectId), prospect);
    response.value = await apiResponse.json();
  } catch (e) {
    response.requestFailed = true;
    response.exception = e;
  }

  return response;
}

export async function DeactivateProspect(data: {
  prospectId: number;
  reason: string;
}): Promise<IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>>> {
  const response: IApiExecuteRespone<IEntityWithMessages<IProspectApiResponse>> = { requestFailed: false };

  try {
    const apiResponse = await httpService.post(ApiUrls.deactivateProspect(data.prospectId), data);
    response.value = await apiResponse.json();
  } catch (e) {
    response.exception = e;
    response.requestFailed = true;
  }

  return response;
}

export async function FreezeProspect(data: {
  prospectId: number;
  thawDate: Date;
}): Promise<IEntityWithMessages<IProspectApiResponse>> {
  try {
    const response = await httpService.post(ApiUrls.freezeProspect(data.prospectId), data);
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function ActivateProspect(prospectId: number): Promise<IEntityWithMessages<IProspectApiResponse>> {
  try {
    const response = await httpService.post(ApiUrls.activateprospect(prospectId));
    return await response.json();
  } catch (e) {
    throw e;
  }
}

export async function CreateProspect(data: {
  zipcode: string;
  name: string;
}): Promise<IEntityWithMessages<IProspectApiResponse>> {
  try {
    const response = await httpService.post(ApiUrls.prospectsRoot(), data);
    return await response.json();
  } catch (e) {
    throw e;
  }
}
